import React, { useEffect } from "react";

const STYLE_ID = "babble-tile-buddy-styles";

const woodBlock = `
  background: linear-gradient(135deg, #fbe3c5, #dfa665);
  border: 1px solid #c37b32;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(92,52,15,.2);
`;

const css = `
@keyframes babbleBuddyIdle {
  0% { transform: translateY(0px) rotate(-1deg); }
  50% { transform: translateY(-3px) rotate(1deg); }
  100% { transform: translateY(0px) rotate(-1deg); }
}
@keyframes babbleBuddyWait {
  0% { transform: translateY(0) rotate(0deg); }
  35% { transform: translateY(2px) rotate(-2deg); }
  70% { transform: translateY(-1px) rotate(1deg); }
  100% { transform: translateY(0) rotate(0deg); }
}
@keyframes babbleBuddyDance {
  0% { transform: translateY(0) rotate(0deg); }
  25% { transform: translateY(-6px) rotate(8deg); }
  50% { transform: translateY(0) rotate(-6deg); }
  75% { transform: translateY(-5px) rotate(6deg); }
  100% { transform: translateY(0) rotate(0deg); }
}
.babble-buddy {
  width: 80px;
  min-width: 80px;
  height: 120px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 4px;
}
.babble-buddy__head,
.babble-buddy__body {
  width: 52px;
  height: 48px;
  ${woodBlock}
  position: relative;
}
.babble-buddy__body {
  width: 48px;
  height: 44px;
}
.babble-buddy__eyes {
  position: absolute;
  top: 16px;
  left: 14px;
  width: 24px;
  display: flex;
  justify-content: space-between;
}
.babble-buddy__eyes span {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #3b1f05;
  box-shadow: 0 1px 0 rgba(255,255,255,.6);
}
.babble-buddy__mouth {
  position: absolute;
  bottom: 12px;
  left: 50%;
  width: 18px;
  height: 4px;
  border-bottom: 3px solid #3b1f05;
  border-radius: 50% 50% 0 0;
  transform: translateX(-50%);
}
.babble-buddy__limb {
  width: 14px;
  height: 40px;
  ${woodBlock}
  position: absolute;
  background-clip: padding-box;
}
.babble-buddy__limb--arm {
  top: 46px;
  width: 14px;
  height: 34px;
}
.babble-buddy__limb--arm-left {
  left: 2px;
  transform-origin: top right;
}
.babble-buddy__limb--arm-right {
  right: 2px;
  transform-origin: top left;
}
.babble-buddy__limb--leg {
  bottom: 0;
  height: 38px;
}
.babble-buddy__limb--leg-left {
  left: 18px;
  transform-origin: top center;
}
.babble-buddy__limb--leg-right {
  right: 18px;
  transform-origin: top center;
}
.babble-buddy--idle .babble-buddy__core {
  animation: babbleBuddyIdle 2.4s ease-in-out infinite;
}
.babble-buddy--waiting .babble-buddy__core {
  animation: babbleBuddyWait 3.6s ease-in-out infinite;
  filter: saturate(.8);
}
.babble-buddy--dance .babble-buddy__core {
  animation: babbleBuddyDance 0.9s ease-in-out infinite;
}
.babble-buddy--dance .babble-buddy__limb--arm-left {
  animation: buddyArmWave 0.6s ease-in-out infinite;
}
.babble-buddy--dance .babble-buddy__limb--arm-right {
  animation: buddyArmWave 0.6s ease-in-out infinite alternate;
}
.babble-buddy--dance .babble-buddy__limb--leg-left {
  animation: buddyLegKick 0.7s ease-in-out infinite;
}
.babble-buddy--dance .babble-buddy__limb--leg-right {
  animation: buddyLegKick 0.7s ease-in-out infinite alternate;
}
.babble-buddy--waiting .babble-buddy__mouth {
  border-bottom-width: 2px;
  width: 12px;
  border-bottom-color: #6b4522;
}
.babble-buddy--dance .babble-buddy__mouth {
  border-bottom: none;
  border-top: 3px solid #3b1f05;
  border-radius: 0 0 50% 50%;
}
@keyframes buddyArmWave {
  0% { transform: rotate(0deg); }
  50% { transform: rotate(35deg); }
  100% { transform: rotate(0deg); }
}
@keyframes buddyLegKick {
  0% { transform: rotate(4deg); }
  50% { transform: rotate(-14deg); }
  100% { transform: rotate(4deg); }
}
`;

function ensureStyles() {
  if (typeof document === "undefined") return;
  if (document.getElementById(STYLE_ID)) return;
  const el = document.createElement("style");
  el.id = STYLE_ID;
  el.textContent = css;
  document.head.appendChild(el);
}

export default function BabbleTileBuddy({ mood = "idle" }) {
  useEffect(() => {
    ensureStyles();
  }, []);

  return (
    <div className={`babble-buddy babble-buddy--${mood}`}>
      <div className="babble-buddy__limb babble-buddy__limb--arm babble-buddy__limb--arm-left" />
      <div className="babble-buddy__limb babble-buddy__limb--arm babble-buddy__limb--arm-right" />
      <div className="babble-buddy__limb babble-buddy__limb--leg babble-buddy__limb--leg-left" />
      <div className="babble-buddy__limb babble-buddy__limb--leg babble-buddy__limb--leg-right" />
      <div className="babble-buddy__core" style={{ display:"flex", flexDirection:"column", alignItems:"center", gap:6 }}>
        <div className="babble-buddy__head">
          <div className="babble-buddy__eyes">
            <span />
            <span />
          </div>
          <div className="babble-buddy__mouth" />
        </div>
        <div className="babble-buddy__body" />
      </div>
    </div>
  );
}
